import { Card, DatePicker, Flex } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  type TooltipContentProps,
} from "recharts";
import type { TooltipIndex } from "recharts/types/state/tooltipSlice";

const { RangePicker } = DatePicker;

// #region Sample data
const data = [
  {
    name: "5 Nov",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "7 Nov",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "8 Nov",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "9 Nov",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "10 Nov",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "11 Nov",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "12 Nov",
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
];

const CustomTooltip = ({
  active,
  payload,
}: TooltipContentProps<string | number, string>) => {
  const isVisible = active && payload && payload.length;
  return (
    <div
      className="custom-tooltip"
      style={{ visibility: isVisible ? "visible" : "hidden" }}
    >
      {isVisible && (
        <>
          <div
            className="px-3 py-2 bg-white rounded-lg
      shadow-[0px_3px_16px_0px_rgba(0,0,0,0.08)] inline-flex flex-col justify-start items-start gap-1.5"
          >
            <div className="justify-start text-slate-600 text-sm font-medium">
              ৳54,64,000
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default function SalesStatistics({
  isAnimationActive = true,
  defaultIndex,
}: {
  isAnimationActive?: boolean;
  defaultIndex?: TooltipIndex;
}) {
  return (
    <>
      <Card
        className="rounded-md shadow-md w-full bg-white"
        bodyStyle={{ padding: "18px" }}
      >
        <Flex justify="space-between" align="center" gap={8}>
          <div className="justify-start text-zinc-700 text-lg font-medium w-full">
            Sales Statistics
          </div>
          <RangePicker />
        </Flex>

        <div className="mt-5">
          <BarChart
            style={{
              width: "100%",
              maxWidth: "100%",
              maxHeight: "60vh",
              aspectRatio: 1.618,
            }}
            responsive
            data={data}
            margin={{
              top: 5,
              right: 0,
              left: 0,
              bottom: 0,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis width="auto" />
            <Tooltip
              content={CustomTooltip}
              isAnimationActive={isAnimationActive}
              defaultIndex={defaultIndex}
            />
            <Legend />
            <Bar
              dataKey="pv"
              barSize={20}
              fill="#D7DFE9"
              isAnimationActive={isAnimationActive}
              activeBar={{ fill: "#EC7323" }}
            />
          </BarChart>
        </div>
      </Card>
    </>
  );
}
